import dashboardService from "../services/dashboard.service";

import { Card } from "primereact/card";
import React, { useEffect, useState } from "react";

import { Button } from "primereact/button";

const Dashboard = ({ mostrarMensagem }) => {
  const [dados, setDados] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    carregarDashboard();
  }, []);

  const carregarDashboard = () => {
    setLoading(true);
    dashboardService.gerarHome()
      .then((result) => {
        setDados(result);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Card
        title={() => {
          return (
            <div className="flex align-items-center justify-content-between">
              <span>Bem vindo(a) {dados.nome}!</span>
              <Button
                icon="pi pi-refresh"
                severity="secondary"
                text
                rounded
                onClick={carregarDashboard}
                loading={loading}
                aria-label="Atualizar dashboard"
              />
            </div>
          );
        }}
      >
        <div className="grid">
          <div className="col-12 md:col-6">
            <div className="p-3 border-1 surface-border border-round shadow-2">
              <div className="flex align-items-center mb-3">
                <i className="pi pi-calendar text-xl text-primary mr-2"></i>
                <div className="text-xl font-medium text-900">Agendamentos da Semana Atual</div>
              </div>
              <div className="flex align-items-center justify-content-center">
                <span className={`text-5xl font-bold ${parseInt(dados.agendamentosSemanaSemanaAtual || 0) > 0 ? 'text-primary' : 'text-500'}`}>
                  {dados.agendamentosSemanaSemanaAtual || 0}
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-6">
            <div className="p-3 border-1 surface-border border-round shadow-2">
              <div className="flex align-items-center mb-3">
                <i className="pi pi-calendar-plus text-xl text-primary mr-2"></i>
                <div className="text-xl font-medium text-900">Agendamentos da Próxima Semana</div>
              </div>
              <div className="flex align-items-center justify-content-center">
                <span className={`text-5xl font-bold ${parseInt(dados.agendamentosSemanaSemanaProxima || 0) > 0 ? 'text-primary' : 'text-500'}`}>
                  {dados.agendamentosSemanaSemanaProxima || 0}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 p-3 border-1 surface-border border-round bg-primary-50">
          <div className="flex align-items-center">
            <i className="pi pi-info-circle text-primary mr-2"></i>
            <div className="text-primary">
              {parseInt(dados.agendamentosSemanaSemanaAtual || 0) === 0 && parseInt(dados.agendamentosSemanaSemanaProxima || 0) === 0 ? (
                <span>Você não tem agendamentos para as próximas semanas. Que tal começar a agendar suas sessões?</span>
              ) : parseInt(dados.agendamentosSemanaSemanaAtual || 0) > 5 ? (
                <span>Você tem uma semana movimentada! Não se esqueça de verificar todos os seus agendamentos.</span>
              ) : parseInt(dados.agendamentosSemanaSemanaProxima || 0) > parseInt(dados.agendamentosSemanaSemanaAtual || 0) ? (
                <span>A próxima semana será mais movimentada que a atual. Prepare-se!</span>
              ) : (
                <span>Confira seus agendamentos na tela de Pesquisa de Agendamentos.</span>
              )}
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default Dashboard;
